module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitle"
  }, [_vm._v("CONTENTS"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/06preface.htm"
    }
  }, [_vm._v("PREFACE")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/07ack.htm"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch01.htm"
    }
  }, [_vm._v("CHAPTER 1"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Introduction: An Eight-Hundred-Pound Gorilla")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/part1.htm"
    }
  }, [_c('b', [_vm._v("part one. the cold war era")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch02.htm"
    }
  }, [_vm._v("CHAPTER 2"), _c('br'), _vm._v(" "), _c('b', [_vm._v("An Alliance of Necessity: The Secret Friendship of the Shah")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch03.htm"
    }
  }, [_vm._v("CHAPTER 3"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Rise of Israel, Rise of Iran")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch04.htm"
    }
  }, [_vm._v("CHAPTER 4"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Iran's Quest for Supremacy")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch05.htm"
    }
  }, [_vm._v("CHAPTER 5"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Sealing Demise in the Moment of Triumph")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch06.htm"
    }
  }, [_vm._v("CHAPTER 6"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Megalomania")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch07.htm"
    }
  }, [_vm._v("CHAPTER 7"), _c('br'), _vm._v(" "), _c('b', [_vm._v("The Rise of Begin and the Israeli Right")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch08.htm"
    }
  }, [_vm._v("CHAPTER 8"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Enter the Sign of God")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch09.htm"
    }
  }, [_vm._v("CHAPTER 9"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Ideological Shifts, Geopolitical Continuities")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch10.htm"
    }
  }, [_vm._v("CHAPTER 10"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Saddam Attacks!")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch11.htm"
    }
  }, [_vm._v("CHAPTER 11"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Scandal")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch12.htm"
    }
  }, [_vm._v("CHAPTER 12"), _c('br'), _vm._v(" "), _c('b', [_vm._v("The Dying Gasp of the Periphery Doctrine")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/part2.htm"
    }
  }, [_c('b', [_vm._v("part two. the unipolar era")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch13.htm"
    }
  }, [_vm._v("CHAPTER 13"), _c('br'), _vm._v(" "), _c('b', [_vm._v("The New World Order")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch14.htm"
    }
  }, [_vm._v("CHAPTER 14"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Trading Enemies")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch15.htm"
    }
  }, [_vm._v("CHAPTER 15"), _c('br'), _vm._v(" "), _c('b', [_vm._v("From Cold Peace to Cold War")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch16.htm"
    }
  }, [_vm._v("CHAPTER 16"), _c('br'), _vm._v(" "), _c('b', [_vm._v("With Likud, the Periphery Doctrine Returns")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch17.htm"
    }
  }, [_vm._v("CHAPTER 17"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Khatami's Détente")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch18.htm"
    }
  }, [_vm._v("CHAPTER 18"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Betrayal in Afghanistan")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch19.htm"
    }
  }, [_vm._v("CHAPTER 19"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Snatching Defeat from the Jaws of Victory")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/part3.htm"
    }
  }, [_c('b', [_vm._v("part three. looking ahead")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch20.htm"
    }
  }, [_vm._v("CHAPTER 20"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Facing the Future, Facing Reality")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/note.htm"
    }
  }, [_vm._v("NOTES")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/appa.htm"
    }
  }, [_vm._v("APPENDIX A: IRAN'S MAY 2003 NEGOTIATION PROPOSAL"), _c('br'), _vm._v("TO THE UNITED STATES")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/appb.htm"
    }
  }, [_vm._v("APPENDIX B: ORIGINAL U.S. DRAFT NEGOTIATION PROPOSAL")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/appc.htm"
    }
  }, [_vm._v("APPENDIX C: LETTER FROM AMBASSADOR GULDIMANN"), _c('br'), _vm._v("TO THE U.S. STATE DEPARTMENT")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-747c568a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/05-contents.vue
// module id = 69
// module chunks = 0